import {
  arbitrum,
  base,
  bsc,
  bscTestnet,
  linea,
  mainnet,
  polygon,
  sonic,
} from "@reown/appkit/networks";
import { CHAIN_ID } from "./components/ido-details/sale-widget/networks.types";

export type CustomChainUrl = {
  chainId: number;
  rpcUrl: string;
};

const customChainsUrls: CustomChainUrl[] = [];

export const customChains = [
  {
    id: 80094,
    name: "Berachain",
    network: "Berachain",
    nativeCurrency: {
      decimals: 18,
      name: "Bera",
      symbol: "BERA",
    },
    rpcUrls: {
      public: {
        http: ["https://rpc.berachain.com"],
      },
      default: {
        http: ["https://rpc.berachain.com"],
      },
    },
    blockExplorers: {
      default: {
        name: "Berachain Explorer",
        url: "https://berascan.com",
      },
    },
    contracts: {
      multicall3: {
        address: "0xcA11bde05977b3631167028862bE2a173976CA11",
        blockCreated: 30000000,
      },
    },
  },
  {
    id: 13371,
    name: "Immutable zkEVM",
    network: "Immutable zkEVM",
    nativeCurrency: {
      decimals: 18,
      name: "IMX",
      symbol: "IMX",
    },
    rpcUrls: {
      public: {
        http: ["https://rpc.immutable.com"],
      },
      default: {
        http: ["https://rpc.immutable.com"],
      },
    },
    blockExplorers: {
      default: {
        name: "Immutable Explorer",
        url: "https://explorer.immutable.com",
      },
    },
    contracts: {
      multicall3: {
        address: "0xcA11bde05977b3631167028862bE2a173976CA11",
        blockCreated: 1,
      },
    },
  },
] as const;

export const customChainsTestnet = [
  {
    id: CHAIN_ID.ARBITRUM_TESTNET,
    name: "Arbitrum Sepolia Testnet",
    network: "Arbitrum Sepolia Testnet",
    nativeCurrency: {
      decimals: 18,
      name: "Arbitrum Sepolia Token",
      symbol: "ETH",
    },
    rpcUrls: {
      public: {
        http: ["https://arbitrum-sepolia.blockpi.network/v1/rpc/public"],
      },
      default: {
        http: ["https://arbitrum-sepolia.blockpi.network/v1/rpc/public"],
      },
    },
    blockExplorers: {
      default: {
        name: "Arbitrum Sepolia Testnet",
        url: "https://sepolia.arbiscan.io",
      },
    },
    contracts: {
      multicall3: {
        address: "0xCA11bDE05977b3631167028862be2a173976Ca11",
        blockCreated: 13449775,
      },
    },
  },
  {
    id: CHAIN_ID.LINEA_TESTNET,
    name: "Linea Sepolia Testnet",
    network: "Linea Sepolia Testnet",
    nativeCurrency: {
      decimals: 18,
      name: "Linea Sepolia Token",
      symbol: "ETH",
    },
    rpcUrls: {
      public: {
        http: ["https://rpc.sepolia.linea.build"],
      },
      default: {
        http: ["https://rpc.sepolia.linea.build"],
      },
    },
    blockExplorers: {
      default: {
        name: "Linea Sepolia Testnet",
        url: "https://sepolia.lineascan.build/",
      },
    },
    contracts: {
      multicall3: {
        address: "0xCA11bDE05977b3631167028862be2a173976Ca11",
        blockCreated: 13449775,
      },
    },
  },
  {
    id: CHAIN_ID.IMMUTABLE_ZKEVM_TESTNET,
    name: "Immutable zkEVM Testnet",
    network: "Immutable zkEVM Testnet",
    nativeCurrency: {
      decimals: 18,
      name: "tIMX",
      symbol: "tIMX",
    },
    rpcUrls: {
      public: {
        http: ["https://rpc.testnet.immutable.com"],
      },
      default: {
        http: ["https://rpc.testnet.immutable.com"],
      },
    },
    blockExplorers: {
      default: {
        name: "Immutable zkEVM Testnet Explorer",
        url: "https://explorer.testnet.immutable.com",
      },
    },
    contracts: {
      multicall3: {
        address: "0xcA11bde05977b3631167028862bE2a173976CA11",
        blockCreated: 1,
      },
    },
  },
] as const;

const testnets = [bscTestnet] as const;
const productionChains = [
  bsc,
  linea,
  mainnet,
  arbitrum,
  base,
  polygon,
  sonic,
] as const;

export const chains = [
  ...productionChains,
  ...customChains,
  ...(process.env.REACT_APP_ENVIRONMENT === "development"
    ? [...testnets, ...customChainsTestnet]
    : []),
].map((chain) => {
  const customChainUrl = customChainsUrls.find(
    (customChainsUrl) => customChainsUrl.chainId === chain.id
  );
  if (customChainUrl) {
    return {
      ...chain,
      rpcUrls: {
        ...chain.rpcUrls,
        default: {
          http: [customChainUrl.rpcUrl],
        },
      },
    };
  }
  return chain;
});
